exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pagination-component {\n}\n.pagination-component .page-link {\n  color: #343a40;\n}\n.pagination-component .page-item.active .page-link {\n  background-color: #343a40;\n  border-color: #343a40;\n}\n", ""]);

